import request from '@/utils/request';

export function getStudentGainsIndex() {
  return request({
    url: '/StudentGains/index',
  });
}

export function getStudentGainsExplore(params, silentRequest = false) {
  return request({
    url: '/StudentGains/explore',
    params,
    silentRequest,
  });
}

export function getStudentGainsDetail(id) {
  return request({
    url: '/StudentGains/detail',
    params: {
      id,
    },
  });
}

export function praiseStudentGain(id, action) {
  return request({
    url: '/StudentGains/praise',
    method: 'POST',
    data: {
      id,
      action,
    },
  });
}

export function shareStudentGain(id) {
  return request({
    url: '/StudentGains/share',
    method: 'POST',
    data: {
      id,
    },
  });
}
